// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.operational-log-page {
    min-height: 100vh;
    background: #f5f5f5;
}

.dashboard-header {
    background: white;
    padding: 20px 30px;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.dashboard-header h1 {
    margin: 0;
    font-size: 24px;
    color: #333;
}

.logout-btn {
    background: #dc3545;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
}

.logout-btn:hover {
    background: #c82333;
}

.dashboard-nav {
    background: white;
    padding: 0 30px;
    border-bottom: 1px solid #eee;
    display: flex;
    gap: 10px;
}

.nav-btn {
    background: none;
    border: none;
    padding: 15px 20px;
    cursor: pointer;
    font-size: 14px;
    color: #666;
    border-bottom: 2px solid transparent;
    transition: all 0.2s;
}

.nav-btn:hover {
    color: #007bff;
}

.nav-btn.active {
    color: #007bff;
    border-bottom-color: #007bff;
}

.page-content {
    padding: 20px 30px;
}

.page-header {
    margin-bottom: 20px;
}

.page-header h2 {
    margin: 0 0 5px 0;
    color: #333;
    font-size: 20px;
}

.page-header p {
    margin: 0;
    color: #666;
    font-size: 14px;
}

.filters {
    display: flex;
    gap: 15px;
    margin-bottom: 20px;
    padding: 15px;
    background: #f5f5f5;
    border-radius: 4px;
}

.filter-group {
    display: flex;
    flex-direction: column;
    min-width: 200px;
}

.filter-group label {
    font-size: 12px;
    font-weight: 600;
    color: #666;
    margin-bottom: 5px;
}

.filter-group select {
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
}

.logs-table-container {
    background: white;
    border-radius: 4px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    overflow-x: auto;
}

.logs-table {
    width: 100%;
    border-collapse: collapse;
}

.logs-table thead {
    background: #f8f9fa;
}

.logs-table th {
    padding: 12px;
    text-align: left;
    font-weight: 600;
    color: #333;
    border-bottom: 2px solid #dee2e6;
    font-size: 14px;
}

.logs-table th.sortable {
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    transition: background-color 0.2s;
}

.logs-table th.sortable:hover {
    background-color: #e9ecef;
}

.logs-table td {
    padding: 12px;
    border-bottom: 1px solid #dee2e6;
    font-size: 13px;
}

.logs-table tbody tr:hover {
    background: #f8f9fa;
}

.user-info {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.user-name {
    font-weight: 500;
    color: #333;
}

.user-email {
    font-size: 12px;
    color: #666;
}

.changes-summary {
    max-width: 400px;
    word-wrap: break-word;
    white-space: pre-line;
}

.badge {
    display: inline-block;
    padding: 4px 8px;
    border-radius: 3px;
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
}

.badge-success {
    background: #d4edda;
    color: #155724;
}

.badge-warning {
    background: #fff3cd;
    color: #856404;
}

.badge-danger {
    background: #f8d7da;
    color: #721c24;
}

.badge-scanner {
    background: #cfe2ff;
    color: #084298;
}

.badge-webhook {
    background: #e7d6f5;
    color: #6a1b9a;
}

.badge-policy {
    background: #d1ecf1;
    color: #0c5460;
}

.pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;
    margin-top: 20px;
    padding: 15px;
}

.pagination button {
    padding: 8px 16px;
    background: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
}

.pagination button:hover:not(:disabled) {
    background: #0056b3;
}

.pagination button:disabled {
    background: #6c757d;
    cursor: not-allowed;
    opacity: 0.5;
}

.page-info {
    font-size: 14px;
    color: #666;
}

.loading, .no-data {
    text-align: center;
    padding: 40px;
    color: #666;
    font-size: 14px;
}

.error {
    background: #f8d7da;
    color: #721c24;
    padding: 12px 15px;
    border-radius: 4px;
    margin-bottom: 15px;
    border: 1px solid #f5c6cb;
}
`, "",{"version":3,"sources":["webpack://./src/pages/OperationalLog.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,6BAA6B;IAC7B,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,6BAA6B;IAC7B,aAAa;IACb,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,WAAW;IACX,oCAAoC;IACpC,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;AAC7B","sourcesContent":[".operational-log-page {\n    min-height: 100vh;\n    background: #f5f5f5;\n}\n\n.dashboard-header {\n    background: white;\n    padding: 20px 30px;\n    border-bottom: 1px solid #eee;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.dashboard-header h1 {\n    margin: 0;\n    font-size: 24px;\n    color: #333;\n}\n\n.logout-btn {\n    background: #dc3545;\n    color: white;\n    border: none;\n    padding: 8px 16px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n}\n\n.logout-btn:hover {\n    background: #c82333;\n}\n\n.dashboard-nav {\n    background: white;\n    padding: 0 30px;\n    border-bottom: 1px solid #eee;\n    display: flex;\n    gap: 10px;\n}\n\n.nav-btn {\n    background: none;\n    border: none;\n    padding: 15px 20px;\n    cursor: pointer;\n    font-size: 14px;\n    color: #666;\n    border-bottom: 2px solid transparent;\n    transition: all 0.2s;\n}\n\n.nav-btn:hover {\n    color: #007bff;\n}\n\n.nav-btn.active {\n    color: #007bff;\n    border-bottom-color: #007bff;\n}\n\n.page-content {\n    padding: 20px 30px;\n}\n\n.page-header {\n    margin-bottom: 20px;\n}\n\n.page-header h2 {\n    margin: 0 0 5px 0;\n    color: #333;\n    font-size: 20px;\n}\n\n.page-header p {\n    margin: 0;\n    color: #666;\n    font-size: 14px;\n}\n\n.filters {\n    display: flex;\n    gap: 15px;\n    margin-bottom: 20px;\n    padding: 15px;\n    background: #f5f5f5;\n    border-radius: 4px;\n}\n\n.filter-group {\n    display: flex;\n    flex-direction: column;\n    min-width: 200px;\n}\n\n.filter-group label {\n    font-size: 12px;\n    font-weight: 600;\n    color: #666;\n    margin-bottom: 5px;\n}\n\n.filter-group select {\n    padding: 8px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    font-size: 14px;\n}\n\n.logs-table-container {\n    background: white;\n    border-radius: 4px;\n    box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n    overflow-x: auto;\n}\n\n.logs-table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.logs-table thead {\n    background: #f8f9fa;\n}\n\n.logs-table th {\n    padding: 12px;\n    text-align: left;\n    font-weight: 600;\n    color: #333;\n    border-bottom: 2px solid #dee2e6;\n    font-size: 14px;\n}\n\n.logs-table th.sortable {\n    cursor: pointer;\n    user-select: none;\n    transition: background-color 0.2s;\n}\n\n.logs-table th.sortable:hover {\n    background-color: #e9ecef;\n}\n\n.logs-table td {\n    padding: 12px;\n    border-bottom: 1px solid #dee2e6;\n    font-size: 13px;\n}\n\n.logs-table tbody tr:hover {\n    background: #f8f9fa;\n}\n\n.user-info {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.user-name {\n    font-weight: 500;\n    color: #333;\n}\n\n.user-email {\n    font-size: 12px;\n    color: #666;\n}\n\n.changes-summary {\n    max-width: 400px;\n    word-wrap: break-word;\n    white-space: pre-line;\n}\n\n.badge {\n    display: inline-block;\n    padding: 4px 8px;\n    border-radius: 3px;\n    font-size: 11px;\n    font-weight: 600;\n    text-transform: uppercase;\n}\n\n.badge-success {\n    background: #d4edda;\n    color: #155724;\n}\n\n.badge-warning {\n    background: #fff3cd;\n    color: #856404;\n}\n\n.badge-danger {\n    background: #f8d7da;\n    color: #721c24;\n}\n\n.badge-scanner {\n    background: #cfe2ff;\n    color: #084298;\n}\n\n.badge-webhook {\n    background: #e7d6f5;\n    color: #6a1b9a;\n}\n\n.badge-policy {\n    background: #d1ecf1;\n    color: #0c5460;\n}\n\n.pagination {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 15px;\n    margin-top: 20px;\n    padding: 15px;\n}\n\n.pagination button {\n    padding: 8px 16px;\n    background: #007bff;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n}\n\n.pagination button:hover:not(:disabled) {\n    background: #0056b3;\n}\n\n.pagination button:disabled {\n    background: #6c757d;\n    cursor: not-allowed;\n    opacity: 0.5;\n}\n\n.page-info {\n    font-size: 14px;\n    color: #666;\n}\n\n.loading, .no-data {\n    text-align: center;\n    padding: 40px;\n    color: #666;\n    font-size: 14px;\n}\n\n.error {\n    background: #f8d7da;\n    color: #721c24;\n    padding: 12px 15px;\n    border-radius: 4px;\n    margin-bottom: 15px;\n    border: 1px solid #f5c6cb;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
